export default[
    {
        name: 'AnnualFees',
        path: 'AnnualFee',
        component: () => import('@/pages/AnnualFee/AnnualFeeReminder'),
        meta: { title: '年费提醒-示例' }
    }
]